"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@stt-componentes/core");
var _formik = require("formik");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Grid = function Grid(_ref) {
  var cid10 = _ref.cid10,
    handleDelete = _ref.handleDelete,
    strings = _ref.strings,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var _useFormikContext = (0, _formik.useFormikContext)(),
    submitForm = _useFormikContext.submitForm;
  return /*#__PURE__*/_react["default"].createElement(_core.SttTable, null, /*#__PURE__*/_react["default"].createElement(_core.SttTableHead, null, /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, null, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
    width: "10%"
  }, strings.codigo), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
    width: "45%"
  }, strings.nome), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
    width: "35%"
  }, strings.nomeAbreviado), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
    width: "10%"
  }, strings.excluir))), /*#__PURE__*/_react["default"].createElement(_core.SttTableBody, null, cid10.length === 0 ? /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, {
    key: -1
  }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
    colSpan: 4,
    align: "center"
  }, strings.nenhumCid10Adicionado)) : cid10.map(function (row, index) {
    return /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.codigo), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.nome), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.nome_abreviado), !disabled && /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      align: "center"
    }, /*#__PURE__*/_react["default"].createElement(_core.SttDeleteButton, {
      id: "btn-excluir-cid10-".concat(index),
      onClick: function onClick() {
        handleDelete(index);
        submitForm();
      }
    })));
  })));
};
Grid.propTypes = {
  cid10: _propTypes["default"].array.isRequired,
  strings: _propTypes["default"].object.isRequired,
  handleDelete: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Grid);